/**
 * Utility functions for data formatting
 */

export const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

export const formatDate = (value) => {
  if (!value) return "-";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch (e) {
    console.error("Error formatting date:", e);
    return value;
  }
};

export const formatAddress = (address) => {
  if (!address) return "-";
  const { indirizzo, comune, provincia, cap } = address;
  const parts = [indirizzo, comune, provincia, cap].filter(Boolean).map(val => formatValue(val));
  return parts.length > 0 ? parts.join(", ") : "-";
};

export const getStatusLabel = (row) => {
  const s = row?.stato;
  if (!s) return "-";

  const sStr = s.toString().toLowerCase();

  if (s === 1 || s === "1" || sStr === "in attivazione") return "Registrato";
  if (s === 2 || s === "2" || sStr === "registrato") return "Verificato";
  if (s === 3 || s === "3" || sStr === "attivo") return "Attivo";
  if (s === 4 || s === "4" || sStr === "sospeso") return "Sospeso";
  if (s === 5 || s === "5" || sStr === "disattivo" || sStr === "non attivo") return "Disattivo";

  return s.toString();
};

export const getStatusColor = (row) => {
  const s = row?.stato;
  if (!s) return "default";

  const sStr = s.toString().toLowerCase();

  if (s === 1 || s === "1" || sStr === "in attivazione") return "warning";
  if (s === 2 || s === "2" || sStr === "registrato") return "info";
  if (s === 3 || s === "3" || sStr === "attivo") return "success";
  if (s === 4 || s === "4" || sStr === "sospeso") return "warning";
  if (s === 5 || s === "5" || sStr === "disattivo" || sStr === "non attivo") return "error";

  return "default";
};

export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
 